<!--
~ Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
~ This information is confidential and proprietary to GM Global Technology
~ Operations LLC and may not be used, modified, copied or distributed.
-->

<div class="sidebar" [ngClass]="{'sidebar-open': sidebarOpen }" (click)="emitCloseSidebar()">
  <div class="sidebar-body">
    <div class="sidebar-header"><span>{{'Menu-MenuItem' | translate}}</span></div>
    <a class="sidebar-item" routerLink="/" routerLinkActive="active">{{'Menu-HomePage' | translate}}</a>
    <div *ngIf="isSuperAdmin">
      <div class="sidebar-header"><span>{{'Menu-Administration' | translate}}</span></div>
      <span id="accidentMenu" class="sidebar-item" (mouseover)="mouseoverAccident($event)">{{'Menu-AccidentMain' | translate}}</span>
        <div id="accidentSubMenu" class="collapse" style="margin-left: 20px;">
          <a class="sidebar-item" style="font-size: smaller" routerLink="/admin/accident-causation">Causation Management</a>
          <a class="sidebar-item" style="font-size: smaller" routerLink="/admin/accident-classification">Classification Management</a>
          <a class="sidebar-item" style="font-size: smaller" routerLink="/admin/accident-crash-object">Crash Object Management</a>
          <a class="sidebar-item" style="font-size: smaller" routerLink="/admin/injury-classification">Injury Classification Management</a>
          <a class="sidebar-item" style="font-size: smaller" routerLink="/admin/accident-person-type">Person Type Management</a>
          <a class="sidebar-item" style="font-size: smaller" routerLink="/admin/vehicle-direction">Vehicle Direction Management</a>
        </div>

      <a class="sidebar-item" routerLink="/driverSearchAdd">{{'Menu-AddDrivers' | translate}}</a>
      <a class="sidebar-item" routerLink="/admin/driverlevels">{{'Menu-DrivingLevelManagement' | translate}}</a>
      <a class="sidebar-item" routerLink="/admin/endorsements">{{'Menu-EndorsementManagement' | translate}}</a>
      <a class="sidebar-item" routerLink="/admin/endorsements-gov">{{'Menu-GovernmentEndorsementManagement' | translate}}</a>
      <a class="sidebar-item" routerLink="/admin/licenseTypes">License Type Management</a>
      <a class="sidebar-item" routerLink="/admin/locations">Location Management</a>
      <a class="sidebar-item" routerLink="/admin/location-type">Location Type Management</a>
      <a class="sidebar-item" routerLink="/admin/regions">Region Management</a>
      <a class="sidebar-item" routerLink="/admin/sites">Site Management</a>
      <a class="sidebar-item" routerLink="/admin/training">Training Management</a>
      <a class="sidebar-item" routerLink="/admin/violation-definition">Violation Definition Management</a>
    </div>
    <div *ngIf="isSiteAdmin">
      <div class="sidebar-header"><span>Site Administration</span></div>
      <a class="sidebar-item" routerLink="/driverSearchAdd">Add Drivers</a>
    </div>

    <div *ngIf="isSuperAdmin || isSiteAdmin">
      <div class="sidebar-header"><span>Reports</span></div>
      <a class="sidebar-item" routerLink="/reports/viewreport">View Reports</a>
    </div>
    <div class="sidebar-header"><span>User</span></div>
    <a class="sidebar-item">Logout</a>
  </div>

  <div class="sidebar-footer">
    <div class="separator-line"></div>
    <span>PGA</span>
    <span><i class="fa fa-copyright" aria-hidden="true"></i> GENERAL MOTORS 2018</span>
    <span>All Rights Reserved</span>
  </div>
</div>
